import React from 'react';

// A mobile-friendly action sheet for confirmation dialogs.
export default function ActionSheet({ title, options, onCancel }) {
    return (
        // Overlay to cover the screen
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end" onClick={onCancel}>
            {/* Action Sheet container that slides up */}
            <div className="w-full bg-gray-100 rounded-t-2xl p-4 animate-slide-up" onClick={(e) => e.stopPropagation()}>
                {/* Main options group */}
                <div className="bg-white rounded-xl">
                    <div className="p-4 border-b border-gray-200">
                        <h3 className="text-center text-brand-muted font-semibold">{title}</h3>
                    </div>
                    {options.map((option, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                option.action();
                                onCancel(); // Close the sheet after action
                            }}
                            className={`w-full text-center p-4 text-lg ${option.isDestructive ? 'text-red-600' : 'text-sky-600'} ${index > 0 ? 'border-t border-gray-200' : ''}`}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
                {/* Cancel button group */}
                <div className="bg-white rounded-xl mt-2">
                    <button onClick={onCancel} className="w-full text-center p-4 text-lg text-sky-600 font-bold">
                        Batal
                    </button>
                </div>
            </div>
            <style>{`
                @keyframes slide-up {
                    from { transform: translateY(100%); }
                    to { transform: translateY(0); }
                }
                .animate-slide-up {
                    animation: slide-up 0.3s ease-out;
                }
            `}</style>
        </div>
    );
}
